// Audio controller for sound effects and background music
class SoundManager {
  constructor() {
    this.muted = false;
    this.bgMusic = null;
    this.audioCache = {};
    this.audioCtx = null;
  }

  init() {
    if (!this.audioCtx && typeof window !== 'undefined') {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      if (AudioContext) {
        this.audioCtx = new AudioContext();
      }
    }
  }

  toggleMute() {
    this.muted = !this.muted;
    if (this.bgMusic) {
      if (this.muted) {
        this.bgMusic.pause();
      } else {
        this.bgMusic.play().catch(() => {});
      }
    }
    return this.muted;
  }

  isMuted() {
    return this.muted;
  }

  playBgMusic() {
    if (this.muted) return;
    try {
      if (!this.bgMusic) {
        this.bgMusic = new Audio('/assets/sounds/theme_music.mp3');
        this.bgMusic.loop = true;
        this.bgMusic.volume = 0.25;
      }
      this.bgMusic.play().catch(() => {
        // Autoplay may be restricted until user interacts
      });
    } catch (e) {
      console.warn('Audio play error:', e);
    }
  }

  pauseBgMusic() {
    if (this.bgMusic) {
      this.bgMusic.pause();
    }
  }

  playSound(name) {
    if (this.muted) return;

    const soundMap = {
      pop: '/assets/sounds/sfx_star_pop.mp3',
      tap: '/assets/sounds/sfx_tap.mp3',
      chest: '/assets/sounds/sfx_chest_open.mp3',
      feed: '/assets/sounds/sfx_pet_feed.mp3',
      voice_count: '/assets/sounds/line_tap_count.mp3',
    };

    const src = soundMap[name] || name;

    try {
      const audio = new Audio(src);
      audio.volume = 0.65;
      audio.play().catch(() => {
        this.playSynthesizedTone(name);
      });
    } catch {
      this.playSynthesizedTone(name);
    }
  }

  // Fallback synthesized happy sounds using Web Audio API
  playSynthesizedTone(type) {
    if (this.muted) return;
    try {
      this.init();
      if (!this.audioCtx) return;

      if (this.audioCtx.state === 'suspended') {
        this.audioCtx.resume();
      }

      const now = this.audioCtx.currentTime;
      const osc = this.audioCtx.createOscillator();
      const gain = this.audioCtx.createGain();

      osc.connect(gain);
      gain.connect(this.audioCtx.destination);

      if (type === 'pop') {
        osc.type = 'sine';
        osc.frequency.setValueAtTime(440, now);
        osc.frequency.exponentialRampToValueAtTime(880, now + 0.12);
        gain.gain.setValueAtTime(0.3, now);
        gain.gain.exponentialRampToValueAtTime(0.01, now + 0.15);
        osc.start(now);
        osc.stop(now + 0.15);
      } else if (type === 'chest' || type === 'win') {
        // Joyful chord
        [523.25, 659.25, 783.99, 1046.5].forEach((freq, i) => {
          const o = this.audioCtx.createOscillator();
          const g = this.audioCtx.createGain();
          o.type = 'triangle';
          o.frequency.value = freq;
          o.connect(g);
          g.connect(this.audioCtx.destination);
          g.gain.setValueAtTime(0.15, now + i * 0.08);
          g.gain.exponentialRampToValueAtTime(0.01, now + i * 0.08 + 0.3);
          o.start(now + i * 0.08);
          o.stop(now + i * 0.08 + 0.35);
        });
      } else {
        // Gentle tap
        osc.type = 'sine';
        osc.frequency.setValueAtTime(520, now);
        osc.frequency.exponentialRampToValueAtTime(320, now + 0.08);
        gain.gain.setValueAtTime(0.2, now);
        gain.gain.exponentialRampToValueAtTime(0.01, now + 0.08);
        osc.start(now);
        osc.stop(now + 0.08);
      }
    } catch {
      // AudioContext unavailable
    }
  }
}

export const sounds = new SoundManager();
